module.exports = __webpack_public_path__ + "img/firework-final.bb8d270e.png";